class ContextService {
  static base = '';

  static create = this.base;

  static link = (uuid) => `/links/${uuid}`;
}

export default ContextService;
